export default __webpack_public_path__ + "static/media/MAGAZINE_IVP.e0450d14.mp4";